const i = {
  /** Premium, non-AI tracker features. */
  pro: "pro",
  /** AI Coach. */
  ai: "ai",
  /** Founder — unlimited AI. */
  unlimited: "unlimited"
}, o = {
  [i.pro]: 1,
  [i.ai]: 2,
  [i.unlimited]: 3
};
export {
  i as ENTITLEMENTS,
  o as ENTITLEMENT_RANK
};
